<button
  pButton
  [pTooltip]="gridStore.readonly() ? 'Ansicht editieren' : 'Vorschau'"
  [rounded]="true"
  [icon]="gridStore.readonly() ? 'fas fa-pen' : 'fas fa-eye'"
  (click)="editAtlasToggle()"></button>
